import { REQUEST_ASNYC } from '../constants/asyncRequestTypes';

export default function requestAsync(promise) {
  return {
    type: REQUEST_ASNYC,
    promise,
  };
}
